import { Component, OnInit } from '@angular/core';
import {FormBuilder,FormGroup, Validators} from '@angular/forms'
import {CategoriesService} from '../services/categories.service'; // private gsvc: AppglobalService
import {ContactMsg} from '../models/contact'
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {
  contactForm: FormGroup;
  newsletterForm: FormGroup; 
  loading = true;
  error = "";
  constructor(
    private formBuilder: FormBuilder, 
    private catRep: CategoriesService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    var sliderImages = document.querySelectorAll('.slider-image');
    var currentImageIndex = 0;

    function showNextImage() {
      //sliderImages[currentImageIndex].style.display = 'none';
      currentImageIndex = (currentImageIndex + 1) % sliderImages.length;
      //sliderImages[currentImageIndex].style.display = 'block';
    }

    setInterval(showNextImage, 3000); // Change d'image toutes les 3 secondes

    this.contactForm = this.formBuilder.group({
      contactnom: ['', Validators.required],
      contactwebsite: ['', Validators.required],
      contactmessage: ['', Validators.required],
      contactemail: ['', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]],
      });
  }

  get f() { return this.contactForm.controls; }


  getcontactinfos(){
    if(this.f.contactemail.valid){
          let contactinfos = Object.assign( 
                    {nom:this.f.contactnom.value } , 
                    {email:this.f.contactemail.value},
                    {siteweb :this.f.contactwebsite.value},
                    {message:this.f.contactmessage.value}
          );
          this.loading = true;
          this.error = "";
            this.catRep
                .sendcontactinfos(contactinfos)
                  .subscribe(
                    (response) => {                           //next() callback
                      let Rep = response; 
                    },
                    (error) => {                              //error() callback
                      //console.error('Get footer ville Request failed with error')
                      this.error = error;
                      this.loading = false;
                    },
                    () => {                                   //complete() callback
                    // console.error('Get footer ville Request completed')      //This is actually not needed 
                      this.loading = false; 
                    })
          
    }else{
      this.translate.get('CONTACT.ERROR').subscribe((res: string) => {
        window.alert(res);
      });
    }
    
  }
}
